var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartPie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 127,
    viewBox: "0 0 240 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_199_9374)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M139.788 3.47905C105.867 18.7398 136.657 45.9397 117.072 60.7512C97.4874 75.5628 44.2367 58.4403 64.5383 96.9097C88.3819 142.096 192.801 135.815 215.315 80.3963C237.828 24.9772 173.709 -11.7817 139.788 3.47905Z",
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 23.0078C127.911 23.0078 135.645 25.3538 142.223 29.749C148.801 34.1443 153.928 40.3914 156.955 47.7005C159.983 55.0095 160.775 63.0522 159.231 70.8114C157.688 78.5707 153.878 85.698 148.284 91.2921L140.365 83.3725C144.392 79.3447 147.135 74.2131 148.247 68.6264C149.358 63.0398 148.788 57.249 146.608 51.9865C144.428 46.724 140.737 42.2261 136 39.0615C131.264 35.8969 125.696 34.2078 120 34.2078V23.0078Z",
    fill: "#1E38BE",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 103.008C112.979 103.008 106.081 101.16 100 97.6488L105.6 87.9493C109.978 90.4771 114.945 91.8078 120 91.8078V103.008Z",
    fill: "#6578DE",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 97.6488C93.9192 94.1381 88.8697 89.0886 85.359 83.0078C81.8482 76.927 80 70.0293 80 63.0078H91.2C91.2 68.0633 92.5307 73.0297 95.0585 77.4078C97.5862 81.786 101.222 85.4216 105.6 87.9493L100 97.6488Z",
    fill: "#8C9AE6",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 63.0078C80 57.7549 81.0346 52.5535 83.0448 47.7005C85.055 42.8474 88.0014 38.4379 91.7157 34.7235L99.6353 42.6431C96.961 45.3175 94.8396 48.4923 93.3923 51.9865C91.9449 55.4807 91.2 59.2257 91.2 63.0078H80Z",
    fill: "#B2BBEE",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7157 34.7235C95.4301 31.0092 99.8396 28.0628 104.693 26.0526C109.546 24.0424 114.747 23.0078 120 23.0078V34.2078C116.218 34.2078 112.473 34.9527 108.979 36.4001C105.485 37.8474 102.31 39.9688 99.6353 42.6431L91.7157 34.7235Z",
    fill: "#F0F3FF",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.284 91.2921C140.783 98.7935 130.609 103.008 120 103.008V91.8078C127.638 91.8078 134.964 88.7735 140.365 83.3725L148.284 91.2921Z",
    fill: "#465DD8",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 43.0078,
    width: 60,
    height: 4,
    rx: 2,
    fill: "#DFE2E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 43.0078,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#B2BBEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 83.0078,
    width: 45,
    height: 4,
    rx: 2,
    fill: "#DFE2E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 83.0078,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#8C9AE6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 111.008,
    width: 48,
    height: 4,
    rx: 2,
    fill: "#DFE2E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 111.008,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#6578DE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 103.008,
    width: 85,
    height: 4,
    rx: 2,
    fill: "#DFE2E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 103.008,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#465DD8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 51.0078,
    width: 25,
    height: 4,
    rx: 2,
    fill: "#DFE2E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 51.0078,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#1E38BE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 15.0078,
    width: 42,
    height: 4,
    rx: 2,
    fill: "#DFE2E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 15.0078,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#F0F3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_199_9374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 127,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPie);
export default __webpack_public_path__ + "static/media/ChartPie.066b9397.svg";
export { ForwardRef as ReactComponent };